define(["require", "exports", "./core/AxiosHttpRequest", "./services/BookingService", "./services/ConferenceService", "./services/HostService", "./services/HostAuthService", "./services/ParticipantService", "./services/SkillSetService"], function (require, exports, AxiosHttpRequest_1, BookingService_1, ConferenceService_1, HostService_1, HostAuthService_1, ParticipantService_1, SkillSetService_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.NotifiedClient = void 0;
    class NotifiedClient {
        constructor(openApiConfig, HttpRequest = AxiosHttpRequest_1.AxiosHttpRequest) {
            var _a;
            this.request = new HttpRequest({
                base: process.env.REACT_APP_NotifiedClient_OVERRIDE || 'https://notified-booking-api.{edge}.ciptex.io',
                edge: (_a = openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.edge) !== null && _a !== void 0 ? _a : 'gll',
                version: '1.0',
                token: openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.token,
                accountSid: openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.accountSid,
                authToken: openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.authToken
            });
            this.booking = new BookingService_1.BookingService(this.request);
            this.conference = new ConferenceService_1.ConferenceService(this.request);
            this.host = new HostService_1.HostService(this.request);
            this.hostauth = new HostAuthService_1.HostAuthService(this.request);
            this.participant = new ParticipantService_1.ParticipantService(this.request);
            this.skillset = new SkillSetService_1.SkillSetService(this.request);
        }
    }
    exports.NotifiedClient = NotifiedClient;
});
